import { IRouteProps } from 'umi';

export const dva = {
  config: {
    onError(err: any) {
      err.preventDefault();
    },
  },
};

// 路由监听，当支付完成时，拦截路由，根据返回的quote_id，跳转到指定的 policy detail页面
export const onRouteChange = ({ location, routes, action }: IRouteProps) => {
  return routes;
};
